import {TRANSACTIONAL_ITEMS_API_HOST} from '../../constants/app';
import getMemberToken from '../../utils/getMemberToken';
import {wishlistCreated} from '../../analytics';

const TransactionalItemsApi = {
  addRegistryItem: async ({memberId, item}) => {
    const res = await fetch(
      `${TRANSACTIONAL_ITEMS_API_HOST}/registry/${memberId}/items`,
      {
        method: 'POST',
        headers: {
          'MEMBERSHIP-SESSION-TOKEN': getMemberToken(),
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(item),
      },
    );

    if (!res.ok) {
      const errorResponse = await res.json();
      const error = new Error(errorResponse.message);
      error.status = res.status;

      throw error;
    }

    const jsonResponse = await res.json();

    const isWishlistCreated = res.headers.get('wishlist-created') === 'true';

    if (isWishlistCreated) {
      wishlistCreated({
        wishlist_id: memberId,
        wishlist_name: 'Transactional Registry',
      });
    }

    return jsonResponse;
  },

  removeRegistryItem: async ({memberId, sku, configurableSku = undefined}) => {
    const res = await fetch(
      `${TRANSACTIONAL_ITEMS_API_HOST}/registry/${memberId}/items/${sku}${
        configurableSku ? `/${configurableSku}` : ''
      }`,
      {
        method: 'DELETE',
        headers: {
          'MEMBERSHIP-SESSION-TOKEN': getMemberToken(),
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      },
    );

    if (!res.ok) {
      const errorResponse = await res.json();
      const error = new Error(errorResponse.message);
      error.status = res.status;

      throw error;
    }

    return res;
  },

  getRegistryItems: async ({memberId}) => {
    const res = await fetch(
      `${TRANSACTIONAL_ITEMS_API_HOST}/registry/${memberId}/items`,
      {
        method: 'GET',
        headers: {
          'MEMBERSHIP-SESSION-TOKEN': getMemberToken(),
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      },
    );

    if (!res.ok) {
      const errorResponse = await res.json();
      const error = new Error(errorResponse.message);
      error.status = res.status;

      throw error;
    }

    const jsonResponse = await res.json();

    return jsonResponse;
  },
};

export default TransactionalItemsApi;
